import {Address} from './address';
export class ModelInfo {
  modelName: string;
  community: string;
  builder: string;
  address: Address;

  constructor(public data: any) {
    const json: JSON = data;

    this.modelName = json['modelName'];
    this.community = json['community'];
    this.builder = json['builder'];
    if (json['address']) {
      this.address = new Address(json['address']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/model/model-info.ts